import React from 'react';
import './css/DashboardControls.css';

/**
 * DashboardControls component displays analysis information in a table format
 * 
 * @param {Object} props
 * @param {Object} props.analysisInfo - Contains model, region, processing time and processed at info
 */
const DashboardControls = ({ analysisInfo }) => {
  if (!analysisInfo) return null;
  
  const { model, region, processingTime, processedAt } = analysisInfo;
  
  return (
    <div className="dashboard-controls">
      <h3>Analysis Information</h3>
      <table className="analysis-table">
        <thead>
          <tr>
            <th>Model</th>
            <th>Region</th>
            <th>Processing Time</th>
            <th>Processed At</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>{model}</td>
            <td>{region}</td>
            <td>{processingTime}</td>
            <td>{processedAt}</td>
          </tr>
        </tbody>
      </table>
    </div>
  );
};

export default DashboardControls; 